<template>
    <div class="lang_options-container">
        <img :src="'data:image/svg+xml;base64, ' + getActiveLang.imgSrc" alt="language_active_flag_icon">
        <span class="text">{{getActiveLang.name}}</span>
        <span class="icon-bottom_arrow"/>
        <div class="wrapper">
            <div class="links-container">
                    <div v-for="element in getLangsList"
                         class="lang"
                         @click="selectLang(element.id, element.name, element.imgSrc)">
                        <img :src="'data:image/svg+xml;base64, ' + element.imgSrc" alt="language_flag">
                        <span class="text">{{element.name}}</span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LangOptions",
        methods: {
            selectLang(id, name, imgSrc) {
                this.$store.commit({
                    type: 'selectLang',
                    name: name,
                    imgSrc: imgSrc,
                    id: id
                })
            }
        },

        computed: {

            getActiveLang() {
                return this.$store.state.activeLang;
            },

            getLangsList(){
                return this.$store.state.languages;
            }

        },
    }
</script>